import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`

export const ButtonsWrapper = styled.div`
  margin-bottom: 20px;
  button {
    width: 100%;
  }

  button + button {
    margin-top: 20px;
  }
`
